import { equals, propOr, __, anyPass, pipe, map } from 'ramda';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AsyncLoader from '../../components/AsyncComponentLoader';
import clientIdConfig from '../../../../config/ClientIdConfig';
import { clearMessage } from '../../../../core/alert';
import { selectMessage } from '../../../../core/alert/selectors';
import {
  selectClient,
  selectClientName,
  selectPasswordReset,
  selectReturningUser
} from '../../../../core/auth/selectors';
import {
  loginRequestAction,
  newPasswordRequest,
  resetPasswordRequest,
  forgotPasswordConfirm,
  setReturningUser
} from '../../../../core/auth';

const AsyncLogin = AsyncLoader(() => import('../../components/GenericLogin'));
const AsyncNewPassword = AsyncLoader(() => import('../../components/GenericNewPassword'));
const AsyncForgotPassword = AsyncLoader(() => import('../../components/GenericForgotPassword'));
const AsyncForgotPasswordConfirm = AsyncLoader(() =>
  import('../../components/ForgotPasswordConfirm')
);

export default mapperFor => {
  const actions = {
    login: loginRequestAction,
    new_password: newPasswordRequest,
    forgot_password: resetPasswordRequest,
    forgot_password_confirm: forgotPasswordConfirm
  };
  const genericComponents = {
    login: AsyncLogin,
    new_password: AsyncNewPassword,
    forgot_password: AsyncForgotPassword,
    forgot_password_confirm: AsyncForgotPasswordConfirm
  };

  const mapDispatchToProps = dispatch =>
    bindActionCreators(
      {
        onSubmit: actions[mapperFor],
        clearMessage,
        setReturningUser,
        selectReturningUser
      },
      dispatch
    );

  const mapStateToProps = state => ({
    message: selectMessage(state),
    clientName: selectClientName(state),
    passwordReset: selectPasswordReset(state),
    client: selectClient(state)
  });

  const isKnownPage = anyPass(
    map(equals(mapperFor), ['login', 'forgot_password', 'forgot_password_confirm'])
  );

  return pipe(
    propOr({}, __, clientIdConfig),
    propOr(genericComponents[mapperFor], mapperFor),
    connect(isKnownPage ? mapStateToProps : null, mapDispatchToProps)
  );
};



// WEBPACK FOOTER //
// ./src/views/common/containers/CommonMapper/index.js